module.exports = __webpack_public_path__ + "static/media/photoshop-illustrator.c6cc9d29.png";